export default __webpack_public_path__ + "static/media/180.c6237002.png";